import { motion } from "framer-motion";
import cornerFlower from "@/assets/decoration/corner-flower.png";

interface QuoteSectionProps {
  cornerFlower?: string;
}

export function QuoteSection({ cornerFlower: flowerUrl }: QuoteSectionProps) {
  return (
    <section
      id="quotes"
      className="relative w-full py-24 px-6 bg-white overflow-hidden"
    >
      {/* Top Left Decoration */}
      <motion.img
        src={flowerUrl || cornerFlower}
        alt="Decoration"
        className="absolute top-0 left-0 w-32 md:w-48 opacity-80 pointer-events-none"
        initial={{ opacity: 0, x: -20, y: -20 }}
        whileInView={{ opacity: 0.8, x: 0, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      />

      {/* Bottom Right Decoration (Rotated) */}
      <motion.img
        src={flowerUrl || cornerFlower}
        alt="Decoration"
        className="absolute bottom-0 right-0 w-32 md:w-48 opacity-80 rotate-180 pointer-events-none"
        initial={{ opacity: 0, x: 20, y: 20 }}
        whileInView={{ opacity: 0.8, x: 0, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      />

      <div className="max-w-2xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="font-serif text-xl text-stone-700 mb-6 font-semibold">
            QS. Ar-Rum: 21
          </h3>
          <p className="font-serif italic text-stone-600 leading-loose text-sm md:text-base mb-6">
            "Dan di antara tanda-tanda (kebesaran)-Nya ialah Dia menciptakan
            pasangan-pasangan untukmu dari jenismu sendiri, agar kamu cenderung
            dan merasa tenteram kepadanya, dan Dia menjadikan di antaramu rasa
            kasih dan sayang. Sungguh, pada yang demikian itu benar-benar
            terdapat tanda-tanda (kebesaran Allah) bagi kaum yang berpikir."
          </p>
        </motion.div>
      </div>
    </section>
  );
}
